import './delivery-banner';
import './global-alerts';
import '../scroll-top';
import './fixed-header';
import '../../components/desktop/Menu';
import '../../components/desktop/Cart';
import '../../libs/jquery.formstyler';
import '../../libs/prettyCheckboxes';
import Cookie from 'js-cookie';

if (typeof window.clarity !== 'undefined' && window.clarity) {
    window.clarity('consent');
}

$('.locale-switcher').click((e) => {
    e.preventDefault();
    e.stopPropagation();
    $(e.target).closest('form').submit();
});

$('#set-mobile-theme-form').click((e) => {
    e.preventDefault();
    e.stopPropagation();
    $(e.target).closest('form').submit();
});

$('.calculator_top').click(ev => {
    import('./calculator').then(module => {
        module.open();
    });
});

$('.call_back').click(() => {
    import('./callback').then(module => {
        module.default();
    });
});

window.checkGoodQuantity = (e, goodId) => {
    import('./quantity').then(module => {
        module.default(e, goodId);
    });
};

$('.user_block .reg_btn').click(() => {
    import('./auth').then(module => {
        module.toggleReg();
    });
});

$('.user_block .entry_btn').click(() => {
    import('./auth').then(module => {
        module.toggleLogin();
    });
});

$('.js-logout').on('click', function (event) {
    event.preventDefault();

    import('./auth').then(module => {
        module.logout.call(this);
    });
});

$('.top_header .your_city .link').click(() => {
    import('./geo').then(module => {
        module.default();
    });
});

$(document).on('click', '.js-favorite-toggle', function (ev) {
    import('../goods-favorite').then(module => {
        module.default.call(this, ev);
    });
});

$(document).on('click', '.js-one-click-btn', function (ev) {
    import('../good-one-click-buy').then(module => {
        module.default.call(this, ev);
    });
});

$('.js-sent-verification').click(function () {
    import('../check-email').then(module => {
        module.default();
    });
});

$('.number_phone').click(function (ev) {
    import('./phones-popup').then(module => {
        module.toggle.call(this, ev);
    });
});

window.addToBascet = (goods_id, name, nameov, namea, isDiscount, reloadPage = false) => {
    import('./cart').then(module => {
        module.add(goods_id, name, nameov, isDiscount, reloadPage);
    });
};

$(document).on('click', '.header .block_cart .caption a', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    import('./alerts').then(module => {
        if ($('.page__order').length > 0) {
            // Вы приступили к оформлентю закза и не можете редактировать товары в корзине
            module.alert(trans('cart.when_ordering'), trans('cart.when_ordering_caption'));
        } else if ($('.page__basket').length > 0) {
            // Вы уже просматриваете Вашу корзину
            module.alert(trans('cart.its_cart'), trans('cart.its_cart_caption'));
        } else {
            import('./cart');

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $('.dialog_cart').hide();
            } else {
                $(this).addClass('active');
                $('.dialog_cart').show();
                $('.top_header .your_city a, .number_phone .icon, .call_back').removeClass('active');
                // $('.dialog_city').hide();
                $('.dialog_phone').hide();
                $('.dialog_call').hide();
            }
        }
    });
});

$('.tablist a').click(function (ev) {
    ev.preventDefault();

    import('../../libs/tabs').then(module => {
        $(this).tab('show');
    });
});

window.changeBrandsFilter = (tech, detail, brand, url, isChecked) => {
    import('../widget-brands').then(module => {
        module.changeBrandsFilter(tech, detail, brand, url, isChecked);
    });
};

$(document).on('hover', '.js-brands-widget', function (ev) {
    import('../widget-brands').then(module => {
        module.togglePreview.call(this);
    });
});

$(document).on('click', '.js-brands-more', function () {
    import('../widget-brands').then(module => {
        module.showMore.call(this);
    });
});

$(document).on('keyup', '.js-brands-search', function () {
    import('../widget-brands').then(module => {
        module.search.call(this);
    });
});

window.searchform = () => {
    import('../search-autocomplete').then(module => {
        module.searchform();
    });
};

$('.js-search-field').on('keyup paste', function () {
    import('../search-autocomplete').then(module => {
        module.lifeSearch();
    });
});

$('body').click(function (ev) {
    if (
        $(ev.target).closest('.pop_up').length === 0 &&
        $(ev.target).closest('.myAlerts').length === 0 &&
        $(ev.target).closest('.calculator_top').length === 0 &&
        $(ev.target).closest('.button_calc').length === 0 &&
        $(ev.target).closest('.user_block').length === 0 &&
        $(ev.target).closest('.dialog_call').length === 0 &&
        $(ev.target).closest('.dialog_phone').length === 0 &&
        $(ev.target).closest('.call_back').length === 0 &&
        $(ev.target).closest('.block_contact').length === 0 &&
        !$(ev.target).hasClass('info_close')
    ) {
        $('.pop_up').css('display', 'none');
        $('.calculator_top').removeClass('active');
    }

    //$('.call_back, .m_title .add_reviews, .number_phone .icon, .header .block_cart .caption a, .user_block .reg_btn, .user_block .reg_btn, #topnav .catalog, .header .search .field').removeClass('active');
});

if ($('.top-referral-banner').length > 0) {
    import('../partnership-timer');
}

if ($('.js-partnership-widget').length > 0) {
    import('../partnership-widget');
}

if ($('.js-copy-clipboard').length > 0) {
    import('clipboard').then(module => {
        const ClipboardJS = module.default;

        new ClipboardJS('.js-copy-clipboard');
    });

    $('.js-copy-clipboard').click(function () {
        import('../../helpers/mix').then(mix => {
            mix.default.loadCSS('css/libs/alertifyjs.css');

            import('alertifyjs').then(alertify => {
                alertify.default.notify($(this).data('success'), 'success', 3);
            });
        });
    });
}

const $phoneEvent = $('.js-open-phone-event');

if ($phoneEvent.length > 0) {
    $phoneEvent.mouseover(function () {
        import('js-cookie').then(Cookie => {
            if (Cookie.default.get('header_phone_opened')) {
                // Not too often
                return;
            }

            Cookie.default.set('header_phone_opened', 1, {expires: 2, path: '/', secure: true});

            // Replace with actual number
            const $replace = $phoneEvent.find('.js-phone-replace');
            $replace.text($replace.data('replace'));

            typeof ga !== 'undefined' && ga?.getAll()?.[0]?.send('event', 'ПросмотрТелефонаПК', 'ПросмотрТелефона');
        });
    });
}
